import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-warn-dialog',
  templateUrl: './warn-dialog.component.html',
  styleUrls: ['./warn-dialog.component.scss'],
  imports: [MatDialogModule, MatIconModule, MatButtonModule, CommonModule],
})
export class WarnDialogComponent {
  dialogRef = inject<MatDialogRef<WarnDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  headline: string;
  content: string;
  confirm: string;
  cancel: string;
  hideCancel = false;
  currentYear = new Date().getFullYear();

  constructor() {
    const data = this.data;

    this.headline = data.headline || 'Warning';
    if (data.aiDisclosure) {
      this.content = `This Confidential Information may not be reproduced in whole or in part, or distributed except by authorized representatives of CapitalROCK. Under no circumstances can CapitalROCK copyrighted or Confidential Information be fed into generative AI or other large language models (LLM) as a prompt or content for such tools. All original material is copyright © ${this.currentYear} CapitalROCK.`;
    } else {
      this.content = data.content;
    }
    this.confirm = data.confirm || 'Save';
    this.cancel = data.cancel || 'Cancel';
    this.hideCancel = data.hideCancel || false;
  }
}
